import { Autocomplete } from "@/components/atoms";
import { useFilterJobs, useUserContext } from "@/providers/contexts";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useJobPostFilterOptions } from "@/hooks";

// Only available to premium users

export const DepartmentFilter = () => {
  const { disabledBasicContent, disabledProContent, isAuthenticated } =
    useUserContext();
  const { filters: jobPostFilters, loading: jobPostFiltersLoading } =
    useJobPostFilterOptions();

  const { filters, dispatch, loading } = useFilterJobs();
  const { selectedDepartments } = filters;
  const departments = jobPostFilters?.departments ?? [];
  const disabledContent =
    disabledBasicContent || disabledProContent || !isAuthenticated;

  const options = departments.map(department => ({
    key: department.id,
    value: department.dept_name,
  }));

  const selectedOptions = selectedDepartments.map(selected => {
    const department = options.find(
      option => option.value === selected.dept_name,
    );
    return {
      key: department?.key ?? "",
      value: department?.value ?? "",
    };
  });

  return (
    <Autocomplete
      componentName={"department-filter"}
      multiple
      inputLabel="Departments"
      options={options}
      value={selectedOptions}
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = departments.filter(department =>
          selectedValues.some(el => el.value === department.dept_name),
        );

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedDepartments: selected },
        });
      }}
      loading={loading || jobPostFiltersLoading}
      disabled={disabledContent}
      tooltipMessage={
        disabledContent
          ? "Upgrade your account to access this feature"
          : undefined
      }
      readMoreLink="/memberships"
    />
  );
};
